// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.checkbox-tag-module__checkbox-tag___oqBTh input[type=checkbox] {
  opacity: 0;
  position: absolute;
  width: 0;
  height: 0;
}
.checkbox-tag-module__checkbox-tag___oqBTh label {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 60px;
  border: 1px solid transparent;
  background-color: rgba(var(--primary600-rgb, 75, 40, 109), 0.1);
  color: var(--neutral100, #2c2e30);
  font-size: 0.75rem;
  cursor: pointer;
}
.checkbox-tag-module__checkbox-tag___oqBTh label:hover {
  border: 1px solid var(--primary600, #4b286d);
}
.checkbox-tag-module__checkbox-tag___oqBTh input[type=checkbox]:checked + label {
  border: 1px solid var(--primary600, #4b286d);
}
.checkbox-tag-module__checkbox-tag___oqBTh input[type=checkbox]:focus-visible + label {
  outline: var(--focus, #2681e1) solid 2px;
  outline-offset: 3px;
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./client/app/react-components/inputs-comp/checkbox-tag/checkbox-tag.module.scss","webpack://./node_modules/wa-storybook/styles/tools/mixins/_focus-outline.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACKE;EACC,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AAGH;AAAC;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,+DAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;AAEH;AADG;EACE,4CAAA;AAGL;AACC;EACE,4CAAA;AACH;AAEC;EC1BG,wCAAA;EACA,mBAAA;AD2BJ","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '~wa-storybook/styles/utils.scss';\n\n.checkbox-tag {\n\n  // Hide the actual checkbox input\n  input[type='checkbox'] {\n   opacity: 0;\n   position: absolute;\n   width: 0;\n   height: 0;\n }\n\n label {\n   display: inline-block;\n   padding: 4px 8px;\n   border-radius: 60px;\n   border: 1px solid transparent;\n   background-color: rgba(color(primary600, true), 0.1);\n   color: color(neutral100);\n   font-size: rem(12);\n   cursor: pointer;\n   &:hover {\n     border: 1px solid color(primary600);\n   }\n }\n\n input[type='checkbox']:checked + label {\n   border: 1px solid color(primary600);\n }\n\n input[type='checkbox']:focus-visible + label {\n   @include focus-outline($applyDirectly: true);\n }\n}\n","@import '../functions/color';\n\n@mixin focus-outline($color: color(focus), $applyDirectly: false) {\n  @if $applyDirectly {\n    outline: $color solid 2px;\n    outline-offset: 3px;\n  } @else {\n    &:focus {\n      outline: $color solid 2px;\n      outline-offset: 3px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox-tag": `checkbox-tag-module__checkbox-tag___oqBTh`
};
export default ___CSS_LOADER_EXPORT___;
